import(/* webpackMode: "eager" */ "/Users/andrejkazimov/Developer/Forecast/apps/miniapp/src/app/profile/page.tsx");
